export default __webpack_public_path__ + "static/media/join-form-mobile-background.1af46c19.jpg";